<template>
  <div>
    <v-data-table
        v-model="selected"
        :headers="headersSecond"
        :items="clients"
        mobile-breakpoint="0"
    >
      <template v-slot:item.logo="{ item }">
        <v-avatar :color="item.hexColor" size="40" class="mr-2">
          <span class="white--text headline">{{ getFirstLetter(item.name) }}</span>
        </v-avatar>
      </template>
      <template v-slot:item.name="{ item }">
        <v-edit-dialog
            large
            @save="updateClient(item)"
            persistent
            :return-value.sync="item.name"
        > {{ item.name }}
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
          >
            <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
          </v-btn> 
        </template>
        <span>{{ languageData.labels.edit }}</span>
      </v-tooltip>
          <template v-slot:input>
            <v-textarea
                class="mt-5"
                v-model="item.name"
                :label="languageData.labels.editName"
                outlined
            ></v-textarea>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.email="{ item }">
        <v-edit-dialog
            large
            @save="updateClient(item)"
            persistent
            :return-value.sync="item.email"
        > {{ item.email }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
            >
              <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
            </v-btn> 
          </template>
          <span>{{ languageData.labels.edit }}</span>
        </v-tooltip>
          <template v-slot:input>
            <v-textarea
                class="mt-5"
                v-model="item.email"
                :label="languageData.labels.editEmail"
                outlined
            ></v-textarea>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.phone="{ item }">
        <v-edit-dialog
            large
            @save="updateClient(item)"
            persistent
            :return-value.sync="item.phone"
        > {{ item.phone }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
            >
              <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
            </v-btn> 
          </template>
          <span>{{ languageData.labels.edit }}</span>
        </v-tooltip>
          <template v-slot:input>
            <v-textarea
                class="mt-5"
                v-model="item.phone"
                :label="languageData.labels.editPhone"
                outlined
            ></v-textarea>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.www="{ item }">
        <v-edit-dialog
            large
            @save="updateClient(item)"
            persistent
            :return-value.sync="item.www"
        > {{ item.www }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
            >
              <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
            </v-btn> 
          </template>
          <span>{{ languageData.labels.edit }}</span>
        </v-tooltip>
          <template v-slot:input>
            <v-textarea
                class="mt-5"
                v-model="item.www"
                :label="languageData.labels.editWww"
                outlined
            ></v-textarea>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.client_type="{ item }">
        <v-form ref="clientTypeForm" v-model="isValidClientTypeForm">
          <v-select v-if="Object.keys(clientsTypes).length > 0"
              :label="languageData.labels.searchClientType"
              v-model="clientsTypes[clientsTypes.findIndex(el => el.id === item.id)]['clientType']"
              :items="getClientTypes"
              item-value="value"
              item-text="name"
              :disabled="item.disableSelect"
              @change="handleChangeClientType"
              :rules="[(v) => !!v || languageData.validation.clientTypeRequired]"
              return-object>
            <template slot='selection' slot-scope='{ item }'>
              <template>
                {{ languageData.clientTypes[item.value] }}
              </template>
            </template>
            <template slot='item' slot-scope='{ item }'>
              <template>
                {{ languageData.clientTypes[item.value] }}
              </template>
            </template>
          </v-select>
        </v-form>
      </template>
      <template v-slot:item.actions="{ item }">
        <td class="justify-center" v-if="!item.disableSelect">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="editClient(item)"
                  icon>
                <v-icon color="fontDefault">edit</v-icon>
              </v-btn>
            </template>
            <span>{{ languageData.operation.edit }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="showDeleteClientModal(item)">
                <v-icon color="fontDefault">delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </td>
        <td class="justify-center" v-if="layout !== 'add' && !noClientType">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  :disabled="!item.projectIds.includes(project.id)"
                  @click="showPlannedContacts(item)">
                <v-icon color="fontDefault">mdi-card-account-phone</v-icon>
              </v-btn>
            </template>
            <span>{{ languageData.labels.showPlannedContacts }}</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
    <ModalInfo @doOperation="deleteClient" :isLoadingBtn="false" :idData="modalDeleteData.idData" :typeInfo="modalDeleteData.typeInfo" :headModal="modalDeleteData.head" :btnDisAgreeText="languageData.modalDelete.btnDisAgreeText" :btnAgreeText="languageData.modalDelete.btnAgreeText" :vis-agree-btn="true" :visDisAgreeBtn="true" @clicked="hideModalDelete" :show-modal="isShowDeleteModal" :text-modal="modalDeleteData.textInfo"></ModalInfo>
    <ModalInfo  :typeInfo="modalDeleteInfoData.typeInfo" :headModal="modalDeleteInfoData.head" :btnAgreeText="languageData.btnAgreeText" @clicked="hideModalDeleteInfo" :show-modal="isShowDeleteModalInfo" :text-modal="modalDeleteInfoData.textInfo"></ModalInfo>
    <template v-if="layout !== 'add' && !noClientType">
      <ModalInfo :layout="'modalSelectTable'" :hidden-agree-btn="true" @clicked="hideModalPlannedContact" :show-modal="isShowPlannedContactModal">
        <template v-slot:header>
          <v-btn
              @click="showModalCreatePlannedContact"
              color="primary"
          >
            {{ languageData.plannedContacts.planContact }}
          </v-btn>

        </template>
        <template v-slot:body>
          <PlannedContactsTable :contactableType="'projectClient'"></PlannedContactsTable>
        </template>
      </ModalInfo>
      <ModalInfo :hidden-agree-btn="true" @clicked="hideModalCreatePlannedContact" :show-modal="isShowCreatePlannedContactModal">
        <template v-slot:header>
          {{ languageData.plannedContacts.planContact }}
        </template>
        <template v-slot:body>
          <PlannedContactForm :layout="'project'" :contactableType="'projectClient'"></PlannedContactForm>
        </template>
      </ModalInfo>
    </template>
    <ModalInfo :layout="'modalClientForm'" persistent :hidden-agree-btn="true" @clicked="hideClientFormModal" :show-modal="showClientFormModal">
      <template v-slot:body>
        <ClientsForm v-if="showClientFormModal" :layout="'editModal'" :clientId="selectedClient"></ClientsForm>
      </template>
    </ModalInfo>
  </div>
</template>

<script type="text/javascript">
import {mapActions, mapState} from "vuex";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import eventBus from "../../../../event-bus/eventBus";
import clientTypes from "../../enums/ClientTypeEnum";
import PlannedContactsTable from "../../../PlannedContacts/components/PlannedContactsTable";
import PlannedContactForm from "../../../PlannedContacts/components/PlannedContactForm";
import ClientsForm from "../../../Clients/components/ClientsForm/ClientsForm.vue"

export default {
  name: "ClientsTableStatic",
  props: {
    layout: String,
    clients: Array,
    clientsTypes: Array,
    noClientType: Boolean,
  },
  mounted() {
    const language = this.getCurrentLanguage;
    const selectTypeClient = this.noClientType !== true;
    this.getHeadersTableSecond({ creds: { language, selectTypeClient } });
    eventBus.$on('savePlannedContactSuccess', () => {
      this.hideModalCreatePlannedContact();
    });
    eventBus.$on('closeClientFormModalEvent', () => {
      this.showClientFormModal = false;
    });
    eventBus.$on("saveProjectFailure", () => {
      if (this.$refs.clientTypeForm) {
        this.isValidClientTypeForm = this.$refs.clientTypeForm.validate();
      }   
    });
  },
  components: {
    PlannedContactsTable,
    PlannedContactForm,
    ModalInfo,
    ClientsForm
  },
  computed: {
    ...mapState("getClients", {
      headersSecond: state => state.headersSecond,
    }),
    ...mapState("deleteClient", {
      isShowDeleteModal: state => state.isShowDeleteModal,
      isLoadingDeleteModal: state => state.isLoadingDeleteModal,
      isShowDeleteModalInfo: state => state.isShowDeleteModalInfo,
      modalDeleteInfoData: state => state.modalDeleteInfoData,
      modalDeleteData: state => state.modalDeleteData
    }),
    ...mapState("updateVisiblePlannedContactModal", {
      isShowPlannedContactModal: state => state.isShowPlannedContactModal,
    }),
    ...mapState("getPlannedContacts", {
      chosenClient: state => state.chosenClient
    }),
    ...mapState("updateCreatePlannedContactModal", {
      isShowCreatePlannedContactModal: state => state.isShowCreatePlannedContactModal
    }),
    ...mapState("getProject", {
      project: state => state.dataReceive
    }),
    ...mapState("preventDataLost", {
      isDataChanged: state => state.isDataChanged,
    }),
    getClientTypes: function() {
      return clientTypes;
    }
  },
  methods: {
    ...mapActions("deleteClient", ["showDeleteModal", 'deleteClientRequest', 'showModalDeleteData', 'hideModalDeleteAction', 'hideModalDeleteInfoAction']),
    ...mapActions("getClients", ["getHeadersTableSecond"]),
    ...mapActions("updateVisiblePlannedContactModal", ["updateVisiblePlannedContactModal"]),
    ...mapActions("getPlannedContacts", ["getPlannedContacts", "prepareClient"]),
    ...mapActions("updateCreatePlannedContactModal", ["updateCreatePlannedContactModal"]),
    ...mapActions("updateClient", ["updateClient"]),
    ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),

    showDeleteClientModal: function (item) {
      var modalDeleteData = {};
      modalDeleteData.name = item.name;
      modalDeleteData.id = item.id;
      this.indexDelete = modalDeleteData.index = this.clients.indexOf(item);
      modalDeleteData.languageData = this.languageData.modalDelete;
      this.showModalDeleteData(modalDeleteData);
    },
    deleteClient(value) {
      eventBus.$emit("deleteClientStep", this.indexDelete, value);
    },
    hideModalDeleteInfo: function() {
      this.hideModalDeleteInfoAction();
    },
    hideModalDelete: function() {
      this.hideModalDeleteAction();
    },
    hideModalPlannedContact () {
      this.updateVisiblePlannedContactModal(false);
    },
    hideModalCreatePlannedContact () {
      this.updateCreatePlannedContactModal(false);
    },
    getFirstLetter(companyName) {
      if(companyName !== undefined) {
        return companyName.charAt(0);
      }
    },
    showPlannedContacts(item) {
      this.prepareClient(item);
      eventBus.$emit("getPlannedContacts");
      this.updateVisiblePlannedContactModal(true);
    },
    showModalCreatePlannedContact() {
      this.updateCreatePlannedContactModal(true);
    },
    editClient(item) {
      this.selectedClient = item;
      this.showClientFormModal = true;
    },
    hideClientFormModal() {
      this.showClientFormModal = false;
    },
    handleChangeClientType() {
      if (!this.isDataChanged) {
        this.updateDataInFormIsChanged(true);
      }
    }
  },
  data() {
    return {
      selected: [],
      modalSaveInfoData: {},
      clientTypeValue: [],
      showClientFormModal: false,
      selectedClient: null,
      isValidClientTypeForm: false,
    }
  },
  beforeDestroy() {
    eventBus.$off('getPlannedContacts');
  }
}
</script>